// extracted by mini-css-extract-plugin
module.exports = {"preSaleBox":"Recommend_preSaleBox___SDEu","recommendBox":"Recommend_recommendBox__C_H8O","recommendPopH5":"Recommend_recommendPopH5__Nci_U"};